<template>
    <form class="row" @submit.prevent="submitForm">
        <help-modal/>
        <div class="col-lg-12">
            <BasicInformationBox
                :mode="mode"
                :contractType="type"
                :contractTypeName="contractTypeName"
                :disabled="isShow"
                :errors="errors"
                :helpPrefix="helpPrefix"
                :inputDate="form.date"
                :inputDetailed="form.detailed"
                :inputMarginType="form.margin_type_id"
                :inputName="form.name"
                :inputNumber="form.number"
                :source="form.source"
                :terms_of_delivery="form.terms_of_delivery"
                :inputTypeOfContract="form.type_of_contract"
                :isConnectedToDocument="isConnectedToDocument"
                :isIssuedDocument="isIssuedDocument"
                :marginTypes="marginTypes"
                :typesOfContract="typesOfContract"
                @inputs="form[$event.name] = $event.value"
            />

            <ContractorBox
                ref="contractorBox"
                :contractor="form.contractor"
                :contractors="contractors"
                :countries="countries"
                :disabled="isShow || isConnectedToDocument"
                :disabledOtherEntity="isShow"
                :errors="errors"
                :hasRecipient="form.has_recipient"
                :hasMatchedJst="form.for_matched_jst"
                :hasMatchedGv="form.for_matched_gv"
                :type="type"
                :forceVies="forceVies"
                :helpPrefix="helpPrefix"
                :idNumber="form.contractor_id_number"
                :idNumbers="idNumbers"
                :permissionsAccess="permissionsAccess"
                :recipient="recipient"
                :mode="mode"
                :requiredFields="requiredFields"
                :otherEntitiesTypes="otherEntitiesTypes"
                :otherEntities="otherEntities"
                :originalCompany="originalCompany"
                :showButtons="{edit: !isShow, create: !isConnectedToDocument && !isShow, show: true}"
                @contractorButtons="contractorButtons"
                @inputs="form[$event.name] = $event.value"
                @recipientInputs="recipient[$event.name] = $event.value"
                @assignRecipient="assignRecipient"
                @resetRecipient="resetRecipient"
                @setRecipient="setRecipient"
                @setJst="setJst"
                @setGv="setGv"
                @addNewOtherEntity="addNewOtherEntity"
                @otherEntityInput="handleChangeOtherEntity"
                @removeOtherEntity="removeOtherEntity"
            />

            <AlertBox name="contractor_completed"/>
            <AlertBox v-if="form.type != 'adding'" name="jst_other_entity_alert_danger"/>
            <AlertBox v-if="form.type != 'adding'" name="vat_other_entity_alert_danger"/>
            <AlertBox v-if="form.type != 'adding'" name="jst_other_entity_alert_warning"/>
            <AlertBox v-if="form.type != 'adding'" name="gv_other_entity_alert_warning"/>
            <ItemsBox
                ref="itemBox"
                :contractDescription="form.description"
                :contractTypeName="contractTypeName"
                :contractType="type"
                :currencies="currencies"
                :currency="form.currency"
                :disabled="isShow || (form.detailed && isConnectedToDocument)"
                :errors="errors"
                :helpPrefix="helpPrefix"
                :isConnectedToDocument="isConnectedToDocument"
                :isSelectedVies="isSelectedIdNumberVies"
                :additionalFields="additionalFields"
                :gtus="gtus"
                :procedures="procedures"
                :items="items"
                :permissionsAccess="permissionsAccess"
                :requiredFields="requiredFields"
                :showUnitPriceCalculation="!type.isMargin"
                :unitPriceCalculation="form.unit_price_calculation"
                :vatRates="vatRates"
                :isSymbolVisible="isSymbolVisible"
                :standardItemCreateRoute="standardItemCreateRoute"
                :standardItems="standardItems"
                @addNewItem="addNewItem"
                @hasExemptVat="setContractorVies"
                @inputs="form[$event.name] = $event.value"
                @itemInput="items[$event.index][$event.name] = $event.value"
                @removeItem="removeItem"
                @addStandardItem="addStandardItem"
            />

            <AlertBox name="no_contractor_vies"/>

            <div class="row">
                <AttachmentsBox
                    :disabled="isShow"
                    :downloadLink="downloadLink"
                    :errors="errors"
                    :files="files"
                    :helpName="helpPrefix + '-004'"
                    :permissionsAccess="permissionsAccess"
                    :requiredFields="requiredFields"
                    @addNewFile="addNewFile"
                    @inputs="files[$event.index][$event.name] = $event.value"
                    @removeAttachment="removeAttachment"
                />

                <RemarksBox v-model="form.remarks" :disabled="isShow" :errors="errors"
                            :requiredFields="requiredFields"
                            :helpName="helpPrefix + '-005'"/>
            </div>
            <BaseBoxSection :forForm="false">
                <div class="col-sm-8">
                    <a @click="cancelEdit()" class="btn btn-white btn-sm">{{ __('cancel') }}</a>
                    <button v-if="!isShow" class="btn btn-primary btn-sm">{{ __('save') }}</button>
                </div>
            </BaseBoxSection>
        </div>
    </form>
</template>

<script>
import BasicInformationBox from "../../components/contract-form/BasicInformationBox";
import BaseBoxSection from "../../components/BaseBoxSection";
import actions from "../../vuex/action_types";
import ContractorBox from "../../components/contract-form/ContractorBox";
import hasPermissions from "../../mixins/hasPermissions";
import AlertBox from "../../components/form/AlertBox";
import ItemsBox from "../../components/contract-form/items/ItemsBox";
import AttachmentsBox from "../../components/contract-form/AttachmentsBox";
import mutation_types from "../../vuex/contract-form/mutation_types";
import RemarksBox from "../../components/contract-form/RemarksBox";
import ContractService from "../../services/ContractService";
import hasRequiredFields from "../../mixins/hasRequiredFields";
import {redirect} from "../../modules/helpers";
import hasVatRates from "../../mixins/hasVatRates";

export default {
    name: "ContractForm",
    components: {RemarksBox, AttachmentsBox, ItemsBox, AlertBox, ContractorBox, BaseBoxSection, BasicInformationBox},
    mixins: [hasPermissions, hasRequiredFields, hasVatRates],
    props: {
        mode: {
            type: String,
            required: true,
        },
        type: {
            type: Object,
            required: true,
        },
        originalCompany: {
            type: Object,
            default: () => {
            },
        },
        contractorId: {
            type: String,
            default: null,
        },
        contractors: {
            type: Array,
            default: () => [],
        },
        countries: {
            type: Array,
            default: () => [],
        },
        idNumbers: {
            type: Array,
            default: () => [],
        },
        currencies: {
            type: Array,
            default: [],
        },
        vatRates: {
            type: Array,
            default: [],
        },
        defaultVatRate: {
            type: Object,
            default: null,
        },
        typesOfContract: {
            type: Array,
            default: [],
        },
        marginTypes: {
            type: Array,
            default: [],
        },
        contractData: {
            type: Object,
            default: null,
        },
        contractId: {
            type: String,
            default: '',
        },
        returnRoute: {
            type: String,
            default: null,
        },
        threshold: {
            type: Number,
            default: 0,
        },
        isSymbolVisible: {
            type: Number,
            default: 0,
        },
        standardItemCreateRoute: {
            type: String,
            default: '',
        },
        standardItems: {
            type: Array,
            default: [],
        },
        additionalFields: {
            type: Array,
            default: () => [],
        },
        gtus: {
            type: Array,
            default: () => [],
        },
        procedures: {
            type: Array,
            default: () => [],
        },
        otherEntitiesTypes:{
            type: Array,
            default: () => [],
        },
        hasExemptVatRate:{
            type: Boolean,
            default : false
        }
    },
    data() {
        return {
            initialized: false,
            changed: false,
            form: {
                type: '',
                type_of_contract: '',
                name: '',
                number: '',
                source: '0',
                terms_of_delivery: '',
                detailed: ['invoicing_pl_margin','invoicing_pl_VAT'].includes(this.type.type_name),
                date: '',
                contractor: -1,
                contractor_id_number: 0,
                has_recipient: false,
                for_matched_jst: false,
                for_matched_gv: false,
                unit_price_calculation: false,
                net_amount: 0,
                vat_amount: 0,
                gross_amount: 0,
                vat_margin_amount: 0,
                currency: 0,
                remarks: '',
                margin_type_id: 0,
            },
            items: [],
            otherEntities: [],
            files: [],
            deletedFiles: [],
            recipient: {
                name: '',
                country_id: '',
                id_type: '',
                id_number: '',
                address: '',
                address_2: '',
                zip: '',
                city: '',
                remarks: '',
                vies: 0,
            },
            errors: null,
        };
    },
    computed: {
        otherEntityJstExists(){
          return this.otherEntities.filter(function (item){
              return item.document_other_entity_type_id == 7
          }).length > 0
        },
        otherEntityVatExists(){
            return this.otherEntities.filter(function (item){
                return item.document_other_entity_type_id == 9
            }).length > 0
        },
        helpPrefix() {
            switch (this.contractTypeName) {
                case 'adding':
                    return 'EOF';
                case 'invoicing_pl_VAT':
                    return 'EOB';
                case 'invoicing_pl_margin':
                    return 'EOC';
                default:
                    return '';
            }
        },
        forceVies(){
            let hasVies = false;
            if(this.type.country_code == null){
                return false;
            }
            for (let item of this.items) {
                let vatRate = this.getVatRate(parseInt(item.vat_rate));

                if (vatRate?.label === "NP. UE" || vatRate?.label === "0% WDT") {
                  hasVies = true;
                }
            }
            return hasVies;
        },
        isConnectedToDocument() {
            return (this.contractData && this.contractData.isConnectedToDocument) ?? false;
        },
        isIssuedDocument() {
            return (this.contractData && this.contractData.isIssuedDocument) ?? false;
        },
        isCreate() {
            return this.mode === 'create' || this.mode === 'copy';
        },
        isShow() {
            return this.mode === 'show';
        },
        isEdit() {
            return this.mode === 'edit';
        },
        cancelRoute() {
            return this.returnRoute ?? '/records/contracts?filters_reset=true';
        },
        downloadLink() {
            return `/records/contracts/${this.contractId}/`;
        },
        selectedContractor() {
            return this.contractors.find(c => c.id === this.form.contractor) || {};
        },

        isSelectedIdNumberVies() {
            let contractorVies = true;
            if(this.otherEntities){

            }
            if (this.form.contractor_id_number === 1) {
                 contractorVies =  !!this.selectedContractor.vies;
            } else if (this.form.contractor_id_number === 2) {
                contractorVies =  !!this.selectedContractor.second_vies;
            }

            return contractorVies && this.allOtherEntitiesHasVies();
        },

        emptyItem() {
            const firstVatRateId = this.vatRates.length > 0 ? this.vatRates[0].id : 0;
            const defaultSelectedVatRateId = this.defaultVatRate ? this.defaultVatRate.id : firstVatRateId;

            return ContractService.getEmptyItem(this.contractTypeName, defaultSelectedVatRateId);
        },
        emptyEntitiesItem(){
            return ContractService.getEmptyOtherEntity();
        },
        emptyFile() {
            return {file: null, name: '', new: true};
        },
        contractTypeName() {
            return this.type.type_name;
        },
        protectUnsavedData() {
            return [this.form, this.items];
        },
        initSummaries() {
            return {net: this.form.net_amount, vat: this.form.vat_amount, gross: this.form.gross_amount};
        },
    },
    watch: {
        protectUnsavedData: {
            deep: true,
            handler() {
                if (this.initialized && !this.changed && this.mode !== 'show') {
                    this.changed = true;
                    setIsUnsavedChange(true);
                }
            },
        },
    },

    methods: {
        handleContractorCompleteAlert(contractor) {
            if (!contractor.is_complete) {
                this.$store.dispatch('addAlert', {
                    name: 'contractor_completed',
                    alert: {
                        type: 'error',
                        title: this.__('warning'),
                        msg: this.__('the_selected_contractor_is_to_be_completed_error'),
                    },
                });
            }
        },
        allOtherEntitiesHasVies(){
            return this.otherEntities.filter(function (item){
                return item.vies;
            }).length === this.otherEntities.length;
        },
        handleChangeOtherEntity(event) {
            var tmp = this.otherEntities[event.index];
            tmp[event.name] = event.value;
            this.$set(this.otherEntities, event.index, tmp);
            this.otherEntities[event.index][event.name] = event.value
            this.$store.dispatch('removeIfExistAlert', 'contractor_completed');
            let filteredEntities = this.otherEntities.filter(entity => {
                return entity.contractor_id > 0 && entity.document_other_entity_type_id == 10;
            });
            const _this = this;
            filteredEntities.forEach(entity => {
                let contractor = this.contractors.find(c => c.id == entity.contractor_id)
                _this.handleContractorCompleteAlert(contractor);
            });
            if(this.form.contractor > 0){
                let contractor = this.contractors.find(c => c.id == this.form.contractor)
                this.handleContractorCompleteAlert(contractor)
            }

            if (event.name == 'document_other_entity_type_id') {
                this.fillOtherEntity(event.index, null, 'reset')
                //original company
                if (event.value == 2) {
                    this.fillOtherEntity(event.index, this.originalCompany, 'original')
                    if(this.forceVies){
                        this.$refs.contractorBox.setVies();
                    }
                }
            }
            if(event.name == 'contractor_id_number_selected'){
                if(this.otherEntities[event.index].document_other_entity_type_id == 2){
                    if(event.value == 1){
                        this.otherEntities[event.index].number_type = this.__(this.originalCompany.number_type)
                        this.otherEntities[event.index].vies = this.originalCompany.number_type_vies
                    }
                    else{
                        this.otherEntities[event.index].number_type = this.__(this.originalCompany.number_type_secondary)
                        this.otherEntities[event.index].vies = this.originalCompany.number_type_secondary_vies
                    }
                    if(this.forceVies){
                        this.otherEntities[event.index].contractor_id_number_selected = this.originalCompany.number_type_vies ? 1 : 2
                        this.$refs.contractorBox.setVies();
                    }
                    else{
                        this.otherEntities[event.index].contractor_id_number_selected = event.value;
                    }
                }
                else{
                    this.otherEntities[event.index].contractor_id_number_selected = event.value;
                    let contractor = this.contractors.find(c => c.id == this.otherEntities[event.index].contractor_id)
                    if(event.value == 1){
                        this.otherEntities[event.index].number_type = this.__(contractor.id_number_type)
                        this.otherEntities[event.index].vies = contractor.vies
                    }
                    else{
                        this.otherEntities[event.index].number_type = this.__(contractor.second_id_number_type)
                        this.otherEntities[event.index].vies = contractor.second_vies
                    }
                    if(this.forceVies){
                        this.otherEntities[event.index].contractor_id_number_selected = contractor.vies ? 1 : 2
                        this.$refs.contractorBox.setVies();
                    }

                }


            }
            if (event.name == 'contractor_id') {
                if (event.value != 0) {
                    let contractor = this.contractors.find(c => c.id == event.value)
                    this.fillOtherEntity(event.index, contractor, 'fill')
                    if(this.forceVies){
                        this.$refs.contractorBox.setVies();
                    }


                } else {
                    this.fillOtherEntity(event.index, null, 'reset')
                }

            }
            if(this.forceVies  && this.otherEntities[event.index].vies == false ){
                this.$store.dispatch('addAlert', {
                    name: 'no_contractor_vies',
                    alert: {
                        type: 'warning',
                        title: this.__('warning'),
                        msg: `${this.__('buyer_or_other_entity_vat_number_missing')} ${this.__('make_sure_it_is_possible')}`,
                    },
                });
            }
            else if(this.forceVies  && this.otherEntities[event.index].vies == true && this.isSelectedIdNumberVies){
                this.$store.dispatch('removeIfExistAlert', 'no_contractor_vies');
            }
            this.handleJstOtherEntityAlert()
            this.handleVatOtherEntityAlert()
        },
        fillOtherEntity(index = null, model = null, type){
            if(type == 'reset'){
                this.otherEntities[index].country = ''
                this.otherEntities[index].number_type = ''
                this.otherEntities[index].address = ''
                this.otherEntities[index].address_2 = ''
                this.otherEntities[index].zip = ''
                this.otherEntities[index].city = ''
                this.otherEntities[index].remarks = ''
                this.otherEntities[index].contractor_id = 0;
                this.otherEntities[index].vies = false;
            }
            else if(type == 'fill'){
                this.otherEntities[index].country = typeof model.country == 'object' ? model.country.country_name : model.country
                this.otherEntities[index].number_type = this.__(model.id_number_type)
                this.otherEntities[index].address = model.address
                this.otherEntities[index].address_2 = model.address_2
                this.otherEntities[index].zip = model.zip
                this.otherEntities[index].city = model.city
                this.otherEntities[index].remarks = model.remarks
                this.otherEntities[index].contractor_id_number_selected = 1;
                this.otherEntities[index].vies = model.number_type_vies
            }
            else if(type == 'original'){
                this.otherEntities[index].country = typeof model.country == 'object' ? model.country.country_name : model.country
                this.otherEntities[index].number_type = this.__(model.id_number_type)
                this.otherEntities[index].address = model.address
                this.otherEntities[index].address_2 = model.address_2
                this.otherEntities[index].zip = model.zip
                this.otherEntities[index].city = model.city
                this.otherEntities[index].remarks = model.remarks
                this.otherEntities[index].name = model.name;
                this.otherEntities[index].number_type = this.__(model.id_number.pattern_name)
                if(this.originalCompany.id_number.id != 18){
                    this.otherEntities[index].contractor_id_number_selected = 1
                }
                else{
                    this.otherEntities[index].contractor_id_number_selected = 2
                }
                if(this.otherEntities[index].contractor_id_number_selected == 1){
                    this.otherEntities[index].number_type = this.__(model.number_type)
                    this.otherEntities[index].vies = model.number_type_vies
                }
                else{
                    this.otherEntities[index].number_type = this.__(model.number_type_secondary)
                    this.otherEntities[index].vies = model.number_type_secondary_vies
                }

            }
        },
        removeOtherEntity(index){
            this.$store.dispatch('removeIfExistAlert', 'contractor_completed');
            this.$delete(this.otherEntities, index);
            this.handleJstOtherEntityAlert()
            this.handleVatOtherEntityAlert()
            this.handleJstOtherEntityWarning()
            this.handleGvOtherEntityWarning()
        },
        restoreSymbol(oldData){
            var standardItemIndex  = sessionStorage.getItem('standard_item_selector')
            if(standardItemIndex != 'null' && standardItemIndex != null){
                var url = window.location.href
                var urlObject = new URL(url);
                var standardItemId = urlObject.searchParams.get('standard_item_id');
                if(!['', null, 'null'].includes(urlObject.searchParams.get('standard_item_id'))){
                    oldData.items[standardItemIndex].standard_item_id = standardItemId;
                    Object.assign(this.$data, oldData);
                }
                sessionStorage.setItem('standard_item_selector', null)
            }
        },
        addStandardItem(index){
            sessionStorage.setItem('standard_item_selector', index)
            this.$store.commit(mutation_types.SET_CONTRACT_FORM, this.$data);
            redirect(this.standardItemCreateRoute, {
                return: (document.URL)
            });
        },
        cancelEdit(){
            const _this = this;
            doAjax('/user-active-routes/destroy-temp-lock', {route:$('#current-route-to-lock').val(), url:$('#current-url-to-lock').val()} ).then(()=>{
                window.location.href = _this.cancelRoute
            })
        },
        addNewFile() {
            this.files.push({...this.emptyFile});
        },
        removeAttachment(index) {
            let deletedFile = this.files[index];
            if (deletedFile.new !== true) {
                this.deletedFiles.push(deletedFile.id);
            }
            this.$delete(this.files, index);
        },
        addNewItem() {
            this.items.push({...this.emptyItem});
        },
        removeItem(index) {
            this.$delete(this.items, index);
            this.$refs.itemBox.emitSummaries();
        },
        getContractorActionUrl(action, contractorId) {
            switch (action) {
                case 'show':
                    return `/records/contractors/${contractorId}`;
                case 'edit':
                    return `/records/contractors/${contractorId}/edit`;
                case 'add':
                    return '/records/contractors/create';
                default:
                    return '';
            }
        },
        getReturnUrl() {
            switch (this.mode) {
                case 'copy':
                case 'create':
                    return `/records/contracts/create/${this.contractTypeName}`;
                case 'show':
                    return `/records/contracts/${this.contractId}`;
                case 'edit':
                    return `/records/contracts/edit/${this.contractId}`;
                default:
                    return '';
            }
        },
        contractorButtons(action, contractorId = null) {
            let url = this.getContractorActionUrl(action, contractorId);
            url += `?return=${this.getReturnUrl()}`;

            this.$store.commit(mutation_types.SET_CONTRACT_FORM, this.$data);

            window.location.href = url;
        },
        showErrorPopup() {
            this.$swal({
                title: this.__("warning_!"),
                html: this.__('cant_save_check_forms_warnings_and_fix_errors'),
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#28a745",
                confirmButtonText: this.$options.filters.capitalize(this.__("ok")),
                reverseButtons: true,
            });
        },
        checkForWarnings() {
            if (this.$store.getters.hasErrorAlerts) {
                this.showErrorPopup();
                return true;
            }

            return false;
        },
        resetRecipient(){
            this.recipient.name = '';
            this.recipient.country_id = '';
            this.recipient.id_type = '';
            this.recipient.id_number = '';
            this.recipient.address = '';
            this.recipient.address_2 = '';
            this.recipient.zip = '';
            this.recipient.city = '';
            this.recipient.remarks = '';
            this.recipient.vies = 0;
            this.recipient.id = 0;
        },
        setGv(){
            this.form.for_matched_jst = false;
            this.handleJstOtherEntityAlert()
            this.handleVatOtherEntityAlert()
            this.handleJstOtherEntityWarning()
            this.handleGvOtherEntityWarning()
        },
        setJst(){
            this.form.for_matched_gv = false;
            this.handleJstOtherEntityAlert()
            this.handleVatOtherEntityAlert()
            this.handleJstOtherEntityWarning()
            this.handleGvOtherEntityWarning()
        },
        setRecipient(contractor, id_number) {
            this.recipient.name = '';
            this.recipient.country_id = '';
            if(id_number == 2){
                this.recipient.id_type = '';
                this.recipient.id_number = '';
            }
            else{
                this.recipient.id_type = '';
                this.recipient.id_number = '';
            }

            this.recipient.address = '';
            this.recipient.address_2 = '';
            this.recipient.zip = '';
            this.recipient.city = '';
            this.recipient.remarks = '';
            this.recipient.vies = 0;
            this.recipient.id = 0;
        },
        assignRecipient(recipient){
            this.recipient = {...recipient}
        },
        setContractorVies() {
            if(this.type.country_code != null)
            {
                this.$refs.contractorBox.setVies();
            }

        },
        appendForm(formData) {
            Object.entries(this.form).forEach(([key, value]) => {
                if(value != null){
                    formData.append(key, value);
                }

            });
        },
        appendRecipient(formData) {
            if (this.form.has_recipient) {
                Object.entries(this.recipient).forEach(([key, value]) => {
                    formData.append(`recipient[${key}]`, value);
                });
            }
        },
        appendOtherEntities(formData) {
            if (this.otherEntities.length > 0) {
                this.otherEntities.forEach((obj, index) => {
                    formData.append(`other_entity_type[${index}]`, obj.document_other_entity_type_id)
                    formData.append(`role_name[${index}]`, obj.role_name)
                    formData.append(`participation[${index}]`, obj.participation)
                    if(obj.contractor_id != 0){
                        formData.append(`other_entity_contractor_id[${index}]`, obj.contractor_id)
                    }
                    else{
                        formData.set(`other_entity_contractor_id[${index}]`,'')
                    }
                    formData.append(`other_entity_contractor_id_number_selected[${index}]`, obj.contractor_id_number_selected)
                });
            }
        },
        appendItems(formData) {
            for (const index in this.items) {
                Object.entries(this.items[index]).forEach(([key, value]) => {
                    if(!(key == 'has_discount' && value == false)){
                        if(value != null){
                            formData.append(`items[${index}][${key}]`, value);
                        }

                    }
                });
            }
        },
        appendAttachments(formData) {
            this.files.forEach((fileItem, index) => {
                if (fileItem.new === true) {
                    formData.append(`files[${index}]`, fileItem.file);
                }
                formData.append(`filenames[${index}][name]`, fileItem.name);
                if (fileItem.id !== undefined) {
                    formData.append(`filenames[${index}][id]`, fileItem.id);
                }
            });

            if (this.deletedFiles.length) {
                formData.append('deleted_files', JSON.stringify(this.deletedFiles));
            }
        },
        async submitForm() {
            if (this.checkForWarnings()) return;

            try {
                toggleLoader(true);
                const formData = new FormData();
                let data = {url: ''};

                this.appendForm(formData);
                this.appendRecipient(formData);
                this.appendOtherEntities(formData);
                this.appendItems(formData);
                this.appendAttachments(formData);
                formData.append('mode', this.mode)
                if (this.isCreate) {
                    ({data} = await this.$store.dispatch(actions.SUBMIT_CONTRACT_FORM, formData));
                    if (this.returnRoute && this.returnRoute.includes('item-price-list')) {
                        window.location.href = '/records/contracts'
                    } else {
                        window.location.href = this.returnRoute ? `${this.returnRoute}?contract_id=${data.contractId}` : data.url
                    }

                } else if (this.isEdit) {
                    ({data} = await this.$store.dispatch(actions.SUBMIT_UPDATE_CONTRACT_FORM, [this.contractId, formData]));
                    const _this = this;
                    doAjax('/user-active-routes/destroy-temp-lock', {route:$('#current-route-to-lock').val(), url:$('#current-url-to-lock').val()} ).then(()=>{
                        window.location.href = _this.returnRoute ? `${_this.returnRoute}?contract_id=${data.contractId}` : data.url;
                    })
                }



            } catch ({response}) {
                this.errors = null;

                if (response && response.status === 422) {
                    this.errors = response.data.errors;
                    this.showErrorPopup();
                } else {
                    toastr.error(`${response.status}: ${response.statusText}`);
                }

                toggleLoader(false);
            }
        },
        addNewOtherEntity(){
            this.otherEntities.push({...this.emptyEntitiesItem});
        },
        handleJstOtherEntityWarning() {
            this.$store.dispatch('removeIfExistAlert', 'jst_other_entity_alert_warning');
            if(this.selectedContractor && this.selectedContractor.remind_jst  && !this.form.for_matched_jst){
                this.$store.dispatch('addAlert', {
                    name: 'jst_other_entity_alert_warning',
                    alert: {
                        type: 'warning',
                        title: this.__('warning'),
                        msg: this.__('jst_contract_alert_warning'),
                    },
                });
            }

        },
        handleGvOtherEntityWarning() {
            this.$store.dispatch('removeIfExistAlert', 'gv_other_entity_alert_warning');
            if(this.selectedContractor && this.selectedContractor.remind_gv && !this.form.for_matched_gv){
                this.$store.dispatch('addAlert', {
                    name: 'gv_other_entity_alert_warning',
                    alert: {
                        type: 'warning',
                        title: this.__('warning'),
                        msg: this.__('gv_contract_alert_warning'),
                    },
                });
            }

        },
        handleJstOtherEntityAlert() {
            this.$store.dispatch('removeIfExistAlert', 'jst_other_entity_alert_danger');
            if(this.form.for_matched_jst && !this.otherEntityJstExists){
                this.$store.dispatch('addAlert', {
                    name: 'jst_other_entity_alert_danger',
                    alert: {
                        type: 'error',
                        title: this.__('warning'),
                        msg: this.__('jst_contract_alert'),
                    },
                });
            }

        },
        handleVatOtherEntityAlert() {
            this.$store.dispatch('removeIfExistAlert', 'vat_other_entity_alert_danger');
            if(this.form.for_matched_gv && !this.otherEntityVatExists){
                this.$store.dispatch('addAlert', {
                    name: 'vat_other_entity_alert_danger',
                    alert: {
                        type: 'error',
                        title: this.__('warning'),
                        msg: this.__('vat_contract_alert'),
                    },
                });
            }

        }
    },

    mounted() {
        const oldData = this.$store.getters.getContractForm;
        if (Object.keys(oldData).length > 0 && !this.isShow) {
            Object.assign(this.$data, oldData);
            this.restoreSymbol(oldData)
            if(this.form.contractor == -1){
                this.form.contractor_id_number = 0;
            }
            else{
                if(this.selectedContractor){
                    if(this.selectedContractor.id_number_id == 18 && this.selectedContractor.second_id_number_id == 18){
                        this.form.contractor_id_number = 0;
                    }
                    else if(this.selectedContractor.id_number_id == 18 && this.selectedContractor.second_id_number_id != 18){
                        this.form.contractor_id_number = 2;
                    }
                    else if(this.selectedContractor.id_number_id != 18 && this.selectedContractor.second_id_number_id == 18){
                        this.form.contractor_id_number = 1;
                    }
                }
            }
            if(this.forceVies){
                setTimeout(()=>{
                    this.$refs.contractorBox.setVies();
                }, 1000)

            }
        } else if (this.contractData) {
            this.form = {...this.contractData.form};
            if(this.contractData.recipient){
                this.recipient = {...this.contractData.recipient};
            }

            this.items = [...this.contractData.items];
            this.otherEntities = [...this.contractData.otherEntities];
            if(this.mode != 'copy'){
                this.files = [...this.contractData.files];
            }


        } else {
            this.form.type = this.contractTypeName;
            this.form.type_of_contract = this.type.sell_or_buy ?? 'sell';
            this.addNewItem();
            this.form.currency = this.currencies.length > 0 ? this.currencies[0].id : 0;
        }

        if (this.contractorId) {
            if(this.contractorId != this.form.contractor){
                this.form.contractor = parseInt(this.contractorId);
                this.form.contractor_id_number = 1;
            }
        }
        if(this.form.contractor > 0){
            this.$refs.contractorBox.handleContractorVies(this.form.contractor_id_number, this.contractors.find(c => c.id == this.form.contractor))
        }
        if(this.type.country_code){
            this.handleJstOtherEntityAlert()
            this.handleVatOtherEntityAlert()
            this.handleJstOtherEntityWarning()
            this.handleGvOtherEntityWarning()
        }


        this.$nextTick(() => {
            this.$refs.itemBox.initSummaries(this.initSummaries);
            this.$store.commit(mutation_types.CLEAR_CONTRACT_FORM);
            toggleLoader(false);
            if (this.mode !== 'show') {
                setCheckUnsavedChangesHandler();
            }
            this.initialized = true;
        });

    },
};
</script>
